import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api.js';
import { queryKeys } from '../../lib/queryKeys.js';

/**
 * The strip above the masthead.
 *
 * Every word, the link, and whether it appears at all are settings — a sale that
 * needs a deploy to start is a sale that starts late. The strip is always the
 * house gold: it is the one band of colour above a black masthead, and a second
 * colour there competes with the logo rather than the offer.
 *
 * There is no close button. A shopper who closed it once never saw the strip
 * again in that browser, which read to the operator as the strip being broken;
 * the admin switch is the one control over whether it shows.
 *
 * It sits outside the sticky header so it scrolls away with the page rather than
 * eating a permanent strip of a phone screen.
 */

export const AnnouncementBar = () => {
  const { data: settings } = useQuery({
    queryKey: queryKeys.settings.public(),
    queryFn: () => api.get('/settings/public'),
    staleTime: 15 * 60 * 1000,
  });

  const promotions = settings?.promotions ?? {};
  const message = promotions.announcementText?.trim() ?? '';

  if (!promotions.announcementEnabled || !message) return null;

  return (
    <div className="bg-brand text-white">
      <div className="mx-auto flex min-h-9 max-w-(--container-content) items-center justify-center px-4 py-2 text-center sm:px-6">
        <p className="text-xs leading-snug font-medium tracking-[0.02em]">
          {message}
          {promotions.announcementLinkLabel && promotions.announcementLinkHref && (
            <>
              {' '}
              <Link
                to={promotions.announcementLinkHref}
                className="ml-1 font-semibold whitespace-nowrap underline decoration-white/50 underline-offset-4 transition-colors hover:decoration-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                {promotions.announcementLinkLabel}
              </Link>
            </>
          )}
        </p>
      </div>

    </div>
  );
};

export default AnnouncementBar;
